import { Plan } from './plans';
import type { CfQualification } from '../features/qualification/communityFibreAPI';

/**
 * The plans to show for a Community Fibre address: the backend's own
 * Community Fibre plan objects (named, priced and couponed in the marketing
 * portal, under whatever ids it gives them), narrowed to those the place
 * can have. Sequoia says only how fast the place can go: the fastest tier
 * it found available, which on G.fast is 1000/100 and on full fibre
 * 2000/200. The backend has already left out the tiers not sold on the
 * place's technology when it was asked with one.
 */
export const plansFromCommunityFibre = (verdict: CfQualification | null, catalogue: Plan[]): Plan[] => {
  if (!verdict || !verdict.serviceable) return [];
  const download = (p: Plan) => p.download ?? p.speed;
  const upload = (p: Plan) => p.upload ?? 0;
  return catalogue
    .filter((p) => download(p) <= verdict.maxDownload && upload(p) <= verdict.maxUpload)
    .map((p): Plan => ({ ...p, network: 'communityfibre' }))
    .sort((a, b) => download(a) - download(b) || upload(a) - upload(b));
};
